import type { User, Department, Group } from '../types';

/**
 * Login status states
 */
export enum LoginStatus {
  NetworkError = 0, // Network unavailable
  Start = 1, // Show login form
  Processing = 2, // Loading/verifying
  Completed = 3, // User authenticated
}

/**
 * Current authenticated user
 * Extends User with authentication-specific fields
 */
export interface CurrentUser extends User {
  // Auth fields
  isSystemAdmin?: boolean;
  permissions?: string[];
  groups?: Group[];
  adminOfPnLs?: Department[];

  // Helper method to check permissions
  canAccessAny: (permissions: string[]) => boolean;

  // Logout method
  logout: () => Promise<void>;
}
